import Jumbotron from './Jumbotron/Jumbotron';
import Heading from './Heading/Heading';

export default {
  'jumbotron': {
    standard: Jumbotron
  },
  'heading': {
    standard: Heading
  }
};
